import { Component } from '@angular/core';

@Component({
    selector: 'login-failed',
    templateUrl: './login-failed.component.html',
    standalone: false
})
export class LoginFailedComponent {}
